














































































import { defineComponent, reactive, toRefs, onMounted, computed } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SumupGroup, SumupGroupDetail, Sheet } from "../../modules/teacher/SumupEdit"


export interface Data {
  sumup_group_id: string
  exec_date: string
  name: string
  sumupGroup: SumupGroup
  sumupGroupDetails: SumupGroupDetail[]
  sheets: Sheet[]
  errors: string[]
  isNew: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      exec_date: "",
      name: "",
      sumupGroup: null,
      sumupGroupDetails: new Array<SumupGroupDetail>(),
      sheets: new Array<Sheet>(),
      errors: [],
      isNew: true
    });

    /******************************
     * 左側テーブルデータ
     * 集計マスタに含まれないsheet
     ******************************/

    const unSelectedSheets = computed((): Sheet[] => {
      return state.sheets.filter(x => !x.isSelected);
    });

    /******************************
     * 右側テーブルデータ
     * 集計マスタに含めるsheet
     ******************************/

    const selectedSheets = computed((): Sheet[] => {
      return state.sheets.filter(x => x.isSelected);
    });

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 選択ボタン押下
     ******************************/

    const sheetSelectClick = (sheet: Sheet) => {
      sheet.isSelected = true;
    }

    /******************************
     * 選択解除ボタン押下
     ******************************/

    const sheetUnselectClick = (sheet: Sheet) => {
      sheet.isSelected = false;
    }

    /******************************
     * 登録ボタン押下
     ******************************/

    const entryClick = async () => {
      
      if (!validate() || !window.confirm('集計マスタを追加しますか？')) {
        return;
      }

      const params = {
        sheet_group_keys: selectedSheets.value.map(x => x.sheet_group_key),
        name: state.name,
        exec_date: state.exec_date
      };

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sumup_edit`, params).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 更新ボタン押下
     ******************************/

    const updateClick = async () => {
      
      state.errors = [];

      if (!validate() || !window.confirm('集計マスタを更新しますか？')) {
        return;
      }

      const params = {
        sheet_group_keys: selectedSheets.value.map(x => x.sheet_group_key),
        name: state.name,
        exec_date: state.exec_date
      };

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sumup_edit/update/${state.sumup_group_id}`, params).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 登録前のデータチェック
     ******************************/

    const validate = () => {
      
      state.errors = [];

      if(state.exec_date.length == 0){
        state.errors.push("実施日が入力されていません。");
      }

      if(state.name.length == 0){
        state.errors.push("集計マスタ名が入力されていません。");
      }

      if(selectedSheets.value.length == 0){
        state.errors.push("試験が１件も選択されていません。");
      }

      const curriculumIds: number[] = [];
      for(const sheet of selectedSheets.value){
        if(curriculumIds.includes(sheet.curriculum_id)){
          state.errors.push(`${context.root.$store.getters.getCurriculumNameById(sheet.curriculum_id)}の試験が複数選択されています。選択可能試験は1教科につき1試験です。`);
          break;
        }
        curriculumIds.push(sheet.curriculum_id);
      }

      return state.errors.length == 0;
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      if(context.root.$route.path.indexOf("new") == -1){
        state.sumup_group_id = context.root.$route.params.sumup_group_id;
        state.isNew = false;
      }
      
      await http.get(`/api/teacher/sumup_edit?sumup_group_id=${state.sumup_group_id}`).then(response => {
        if(!state.isNew){
          state.name = response.data.sumup_group.name;
          state.exec_date = response.data.sumup_group.exec_date;
          state.sumupGroupDetails = response.data.sumup_group_details.map((x: any) => new SumupGroupDetail(x));
        }
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x, state.sumupGroupDetails));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      convertExecDate,
      selectedSheets,
      unSelectedSheets,
      sheetSelectClick,
      sheetUnselectClick,
      entryClick,
      updateClick,
    }
  }
});
